export const ShiftRegistrationEN = {
    "shiftRegistrationSider": {
        "shiftRoster": "Shift registration in month"
    },
    "shiftRegistrationTitle": {
        "STT": "No.",
        "ID": "Employee ID",
        "fullName": "Full Name",
        "department": "Department",
        "jobPosition": "Job Position",
        "totalPoints": "Total Points",
        "points": "Point",
        "hour": "Hour",
        "standardPoints": "Standard Points"
    },
    "shiftRegistrationDetail": {
        "shiftWork": "Shift work:",
        "shiftWorkName": "Shift work name:",
        "shiftWorkCode": "Shift work code:",
        "shiftWorkTime":"Time in/out:",
        "timeNotExist": "No",
        "date": "Date",
        "status": "Status:",
        "draft" : "Draft",
        "pending" : "Pending",
        "approved" : "Approved",
        "denied" : "Denied",
        "expired" : "Expired",
        "inactive" : "Inactive",
        "incomplete" : "Incomplete"
    }
}